import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import { useHistory, withRouter } from 'react-router';
import Sidebar from '../layout/sidebar/Sidebar';
import AddPeople from './addPeople/AddPeople';
import AppointmentsList from './appointmentList/AppointmentsList';
import ClientDetails from './clientDetails/ClientDetails';
import JoinShortCode from './joinFromCode/JoinShortCode';
import HelloOauth from './HelloSignOauthTest/helloOauth';
import CheckForNewClients from './checkNewClients/checkForNewClients';
import * as DONE_ONCE from '../../constants/doneOnceJson';
import * as firebaseDocumentCalls from '../clients/getFirebaseDocumentInfo';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';

import './Home.css';
import Clients from '../clients/Clients';

const Home = (props) => {
	const history = useHistory();
	const { firebase } = useContext(FirebaseContext);
	const [userType, setUserType] = useState('');

	useEffect(() => {
		firebase.auth().onAuthStateChanged(async (user) => {
			if (user) {
				var currentUserId = firebase.auth().currentUser.uid;
				var currentUserType;
				var capFirst;

				console.log('Current user Id; ' + currentUserId);
				await firebase
					.database()
					.ref('/users/' + currentUserId + '/userType')
					.once('value', function (snapshot) {
						currentUserType = snapshot.val();
						console.log('THIS IS USER TYPE: ' + currentUserType);
					});
				setUserType(currentUserType);

				if (
					ALL_DOCUMENTS.allDocumentTypeInfo.hasGottenInfo === false &&
					currentUserType !== 'client' &&
					currentUserType !== null &&
					currentUserType !== undefined
				) {
					firebaseDocumentCalls.GetFirebaseDocumentInformation(firebase);
				}
			}
		});
	}, [userType]);

	return (
		<div id='home'>
			<Sidebar />
			<div className='home-main'>
				<div>
					<h2 id='home-title'>Dashboard</h2>
					{userType === 'admin' || userType === 'superadmin' ? (
						<>
							<JoinShortCode />
							<div className='main-cards'>
								<AddPeople />
								<AppointmentsList />
							</div>
							{/* <Clients /> */}
							{/* <ClientDetails /> */}
						</>
					) : (
						<JoinShortCode />
					)}
					<HelloOauth />
					{console.log(
						'new client to be called ' + DONE_ONCE.doneOnceJson.newClientCheck
					)}
				</div>
			</div>
		</div>
	);
};

export default withRouter(Home);
